export const ADMIN_PATH_NAME = "wellbAdmin2019";
